import { FaLinkedin, FaGithub } from "react-icons/fa";

const coursedetails = [
  {
    id: 2,
    thumbnail: "https://cdn.pixabay.com/photo/2021/03/27/06/31/code-6127616_1280.png",
    title: "MERN Stack Web Development",
    duration: "6 months",
    price: 18750,
    discountedPrice: 11250,
    brochureUrl: "https://drive.google.com/file/d/1ECUf6d48Fyc9xolx7rGc3DGto9Fca65E/view?usp=sharing",
    facultyName: "Tushar De",
    facultyImage: "/images/tushar.jpg",
    facultyRole: "Senior MERN Stack Developer & Instructor",
    facultyBio: "Tushar is a seasonal full stack developer.",
    slug: "mern-stack-web-development",
    description: "Master the MERN stack (MongoDB, Express.js, React.js, Node.js) and become a full-stack web developer. This comprehensive course covers front-end and back-end development, database design, API integration, and deployment strategies to help you build modern, responsive web applications."
  },
  {
    id: 3,
    thumbnail: "https://res.cloudinary.com/duzvsl4hl/image/upload/v1729752378/r7v9zgsnm5ylisbnyefg.png",
    title: "Data Science and Analytics Using AI and Chat GPT",
    duration: "6 months",
    price: 18750,
    discountedPrice: 11250,
    brochureUrl: "https://drive.google.com/file/d/19uj3cYA4OdVF2v_TqI8y4fEkKReyrzqo/view",
    facultyName: "Ushashi Chowdhury & Sayan Barik",
    facultyImages: ["/images/faculty3.png", "/images/faculty4.png"],
    facultyRoles: ["Data Science Lead Instructor", "AI & Machine Learning Specialist"],
    facultyBios: [
      "Ushashi is a data science expert with extensive experience in statistical analysis and machine learning. She has helped students develop strong analytical skills through her structured teaching approach.",
      "Sayan specializes in AI and machine learning applications, with a focus on practical implementation. He brings real-world industry experience to help students understand complex AI concepts and tools."
    ],
    slug: "data-science-and-analytics-using-ai-and-chat-gpt",
    description: "Dive into the world of data science and analytics enhanced by AI and ChatGPT. Learn to collect, analyze, and interpret complex data sets, build predictive models, and leverage AI tools to extract meaningful insights that drive business decisions."
  },
  {
    id: 4,
    thumbnail: "https://img.freepik.com/free-vector/gradient-ui-ux-background_23-2149052117.jpg?t=st=1721394289~exp=1721397889~hmac=34d0c1c8288af07412416562e50d1b6788cf2c4184878e7f8a7c8ec0475d5707&w=1380",
    title: "UXperience: Redefining Graphics and Interface Design",
    duration: "6 months",
    price: 18750,
    discountedPrice: 11250,
    brochureUrl: "https://drive.google.com/file/d/1iDMk59_gvpUvjIZdprPGzWMIpj0fLnNc/view?usp=sharing",
    facultyName: "Sayan Bhattacharjee",
    facultyImage: "/images/",
    facultyRole: "Senior UI/UX Instructor",
    facultyBio: "lorem ipsum",
    slug: "uxperience-redefining-graphics-and-interface-design",
    syllabus: [
      {
        title: "1: Introduction to UI/UX Design",
        description: "Learn the fundamentals of UI/UX design and understand the importance of user-centered design in modern digital products.",
        topics: [
          "Course Introduction",
          "Course objectives",
          "Overview of UI/UX",
          "Importance of UI/UX in modern design",
          "Fundamental Concepts",
          "Differences between UI and UX",
          "Basic principles of design",
          "Examples of good and bad UI/UX",
          "Design Process Overview",
          "Research, ideation, prototyping, testing",
          "Design thinking methodology",
          "Stages of the design process",
          "Importance of user-centered design"
        ]
      },
      {
        title: "2: Research and User Personas",
        description: "Explore user research techniques and learn how to create effective user personas for your design projects.",
        topics: [
          "User Research Techniques",
          "Surveys, interviews, user testing",
          "Competitive analysis, SWOT analysis",
          "Creating User Personas",
          "Importance of personas",
          "How to create and use personas",
          "User Journey Mapping",
          "Mapping user experiences with practical experience",
          "Identifying pain points and opportunities"
        ]
      },
      {
        title: "3: Visual Design Fundamentals",
        description: "Master the core principles of visual design that form the foundation of effective UI/UX design.",
        topics: [
          "Color Theory and Typography",
          "Layout and Composition",
          "Common UI patterns and systems"
        ]
      },
      {
        title: "4: Design Tools",
        description: "Get hands-on experience with industry-standard design tools used by professionals.",
        topics: [
          "Introduction to Design Tools",
          "Overview of popular tools (Figma Design, Figjam, Miro, Flowmapp, Canva, Balsamiq, Milanote, Adobe Illustrator)",
          "Hands-on Practice",
          "Basic functions and features",
          "Creating simple designs and wireframes"
        ]
      },
      {
        title: "5: UX Design Process and Prototyping",
        description: "Learn the UX design process and create prototypes of varying fidelity to test your designs.",
        topics: [
          "Wireframing Basics",
          "Importance of wireframes",
          "Creating wireframes",
          "Low-fidelity and high-fidelity wireframes",
          "Prototyping Techniques",
          "Interactive prototyping techniques"
        ]
      },
      {
        title: "6: User Testing and Feedback",
        description: "Understand how to conduct user testing and incorporate feedback to improve your designs.",
        topics: [
          "Usability Testing Methods",
          "Iterating on Designs"
        ]
      },
      {
        title: "7: Accessibility and Inclusive Design",
        description: "Learn how to design for all users, including those with disabilities, to create truly inclusive products.",
        topics: [
          "Principles of Accessibility",
          "Guidelines and standards (WCAG)",
          "Inclusive Design Practices",
          "Designing for diverse users",
          "Case Studies and Examples",
          "Real-world applications of accessibility"
        ]
      },
      {
        title: "8: Advanced Prototyping and Collaboration",
        description: "Master advanced prototyping techniques and learn how to collaborate effectively with development teams.",
        topics: [
          "Collaboration Tools and Techniques",
          "Working with teams",
          "Handoff to developers",
          "Design Documentation",
          "Creating style guides",
          "Documenting design decisions"
        ]
      },
      {
        title: "9: Capstone Project",
        description: "Apply everything you've learned to a comprehensive capstone project that showcases your skills.",
        topics: [
          "Project Planning and Research",
          "Understanding the project scope",
          "Setting goals and objectives",
          "Research and Personas",
          "Conducting user research",
          "Prototyping and accessibility testing from user end"
        ]
      },
      {
        title: "10: Introduction to Logo Design",
        description: "Learn the fundamentals of logo design and how to create effective brand identities.",
        topics: [
          "Importance of Logos",
          "Evolution of logo design",
          "Importance of logos in branding",
          "Principles of Effective Logo Design",
          "Simplicity, scalability, versatility, and relevance",
          "Case studies of successful logos",
          "Brand Research",
          "Understanding the brand and its audience",
          "Analyzing competitors",
          "Concept Development",
          "Brainstorming and sketching ideas",
          "Creating mood boards and visual inspiration",
          "Logo Design",
          "Typography and Imagery",
          "Choosing the right fonts and symbols",
          "Creating harmony between elements",
          "Digital Tools for Logo Design",
          "Adobe Illustrator, other shortcuts",
          "Creating different versions",
          "Presenting the Logo",
          "Creating a professional presentation for the logo",
          "Showcasing different applications (business cards, website, merchandise)",
          "Logo Guidelines and Brand Identity",
          "Developing a style guide"
        ]
      },
      {
        title: "11: Development of Portfolio",
        description: "Create a professional portfolio that showcases your UI/UX design skills and projects.",
        topics: [
          "Portfolio planning and development",
          "Showcasing your best work",
          "Creating an online presence"
        ]
      }
    ],
    faqs: [
      {
        question: "Do I need prior design experience to take this course?",
        answer: "No, this course is designed for beginners as well as those with some design experience. We start with the fundamentals and gradually move to more advanced concepts."
      },
      {
        question: "What software will I need for this course?",
        answer: "You'll need access to design tools like Figma (which has a free tier), Adobe XD, or Sketch. We'll provide guidance on installation and setup in the course."
      },
      {
        question: "Will I have a portfolio by the end of this course?",
        answer: "Yes! The course includes a capstone project and portfolio development module to help you showcase your skills to potential employers."
      },
      {
        question: "How much time should I dedicate to this course each week?",
        answer: "We recommend dedicating at least 8-10 hours per week to get the most out of the course, including watching lectures, completing assignments, and working on projects."
      },
      {
        question: "Is there job placement assistance after completing the course?",
        answer: "Yes, we offer job placement assistance including resume reviews, portfolio feedback, interview preparation, and connections with our industry partners."
      }
    ],
    description: "Master the art and science of UI/UX design with our comprehensive course. Learn to create intuitive, visually appealing interfaces that provide exceptional user experiences. From research and wireframing to prototyping and testing, this course covers the entire design process with hands-on projects and industry-relevant skills."
  },
  {
    id: 5,
    thumbnail: "https://img.freepik.com/free-vector/posts-concept-illustration_114360-194.jpg?t=st=1716449584~exp=1716453184~hmac=eacafb73c9e436903463237d2002ba6eab1b98671b3aa4359c97fe0285a27ec5&w=740",
    title: "Academic, Non-academic and News Content Writing",
    duration: "5 months",
    price: 18750,
    discountedPrice: 11250,
    brochureUrl: "https://drive.google.com/file/d/1QjZ9BNAHbZ253cgJ_GxS8GrayTAjjTu8/view",
    facultyName: "Sayani Dutta",
    facultyImage: "/images/sayani.jpeg",
    slug: "academic-non-academic-and-news-content-writing",
  },
  {
    id: 6,
    thumbnail: "https://res.cloudinary.com/dgj931yed/image/upload/v1729068314/Desktop_-_1_eitjh3.png",
    title: "Digital Marketing Using Generative AI Tools",
    duration: "6 months",
    facultyImage: "/images/faculty8.png",
    facultyRole: "Digital Marketing Lead Instructor",
    facultyBio: "Nilanjan is a digital marketing expert with a passion for educating students about the latest marketing trends and best practices. He brings real-world industry experience to help students understand complex digital marketing concepts and tools.",
    price: 19750,
    discountedPrice: 11850,
    brochureUrl: "https://drive.google.com/file/d/1R3n1v-JIA4pA1ghYYyOUgmL91MJ91kDw/view",
    facultyName: "Nilanjan Bhadra",
    slug: "digital-marketing-using-generative-ai-tools",
  },
  {
    id: 7,
    thumbnail: "https://res.cloudinary.com/dx9jeosmc/image/upload/v1751872256/basic_video_editing_and_graphic_design_esubsf.png",
    title: "Basic & Advance Video Editing and Graphic design",
    duration: "6 months",
    facultyImage: "/images/molly.png",
    facultyRole: "CAO at Vidyastu",
    facultyBio: "Molly is the Chief Administrative Officer at Vidyastu, where she brings both expertise and energy to the fundamentals of video editing and graphic design. With a strong foundation in visual communication, she approach to teaching is hands-on live project.",
    price: 16800,
    discountedPrice: 10080,
    brochureUrl: "https://drive.google.com/file/d/16B1FPfKTU3Wc6OkZSi3nXtXs1QzI0hen/view?usp=drivesdk",
    facultyName: "Molly Rajbanshi",
    slug: "basic-video-editing-and-graphic-design",
  },
];
export default coursedetails;
